import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import styles from './CardHeader.module.scss';

export type CardHeaderProps = {
  children?: ReactNode;
  className?: string;
};

export const CardHeader: FC<CardHeaderProps> = ({ children, className = '' }) => {
  return <section className={classNames(className, styles.header)}>{children}</section>;
};
